<template>
  <div class="cardType_main">
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="search-line">
      <el-button class="btn-add" icon="el-icon-plus" @click="dialogFormVisible = true" v-if="permissionCodes.indexOf('001009007') !== -1">添加卡类型</el-button>
    </div>
    <table-main :selection=false @deleteLine="deleteLine" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination"  />

    <el-dialog title="配置卡类型 " :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="form">
        <el-form-item label="卡类型名称" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.name" :rows="8"
                    auto-complete="off" id="addCardtype"
                    size="small" />
        </el-form-item>
        <p class="showTs" v-html="namePre"></p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCard" size="small">取消</el-button>
        <el-button type="primary" @click="createCard" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TableMain from '../../../../components/Table/TableMain'
import {api} from '../../../api/ConfigCardType'
import {errorHandler} from '../../../../utils/errorHandler'
import {nError, nSuccess} from '../../../../utils/notice'
import {bus} from '../../../../utils/bus'

export default {
  components: {
    TableMain,
    Breadcrumb},
  name: 'config-card-type',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'ali-config'
      }, {
        value: '卡类型配置'
      }],
      tableHead: [{
        prop: 'erialNumber',
        label: '序号'
      }, {
        prop: 'typeName',
        label: '卡类型名称'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ['cardDelete'],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      form: {
        name: ''
      },
      namePre: '<p>按回车键可同时添加多个(单个名称长度不得超过20个字符)</p>',
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  methods: {
    // 获取卡类型分页
    getPage () {
      this.$axios.post(api.getCardTypePage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            let page = res.data.data.pages
            let pageSize = res.data.data.pageSize
            data.map((v, i) => {
              v.erialNumber = (page - 1) * pageSize + i + 1
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取卡类型列表失败'))
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    // 添加卡类型
    createCard () {
      if (!this.form.name) {
        this.namePre = '<p style="color:red;text-align:center;">请输入卡类型</p>'
        return false
      } else {
        this.namePre = '<p>按回车键可同时添加多个(单个名称长度不得超过20个字符)</p>'
        let typeArr = this.form.name.split('\n')
        let cardArr = []
        typeArr.map((v, i) => {
          cardArr[i] = {}
          cardArr[i].typeName = v
        })
        this.$axios.post(api.addPatchCardType, cardArr)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.form.name = ''
              this.dialogFormVisible = false
              this.getPage()
            }
          })
          .catch(errorHandler('添加失败'))
      }
    },
    // 取消添加
    cancelCard () {
      this.dialogFormVisible = false
      this.form.name = ''
      this.namePre = '<p>按回车键可同时添加多个(单个名称长度不得超过20个字符)</p>'
    },
    // 删除卡类型
    deleteLine (code) {
      let delState = true
      code.map(v => {
        if(v.indexOf('A00000000') !== -1 || v.indexOf('A00000001') !== -1 || v.indexOf('A00000002') !== -1 || v.indexOf('A00000003') !== -1 || v.indexOf('A00000004') !== -1) {
          delState = false
        }
      })
      if (!delState) {
        nError('默认卡类型无法删除')
        return false
      }
      this.$axios.post(api.deleteCardTypeByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-add {
    border: 0;
    color: #FFF;
    padding: 8px 16px;
    background-color: #00a0e6;
  }
  .btn-add:hover {
    background-color: #06b3ff;
  }
</style>

<style lang="less" scoped>
  .el-dialog__header {
    text-align: left;
  }
  .el-textarea__inner {
    width: 80%;
  }
  .cardType_main {
    .el-button:focus, .el-button:hover {
      color: #FFFFFF!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigCardType/ConfigCardType.vue